export default __webpack_public_path__ + "static/headstand-bodycenter-1-4cb6b774c14849c9953010b6da9d53cb.jpg";